import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import { install } from '@hnkj/hn-h5-ui'
import './assets/css/main.css'
import vaxTool from '@hnkj/vax_tool'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import CommonComponents from './components/common'
import { Toast } from 'vant'

const VaxApp = window.vaxApp
const app = new VaxApp(process.env.NODE_ENV)

CommonComponents.forEach(item => {
  Vue.use(item)
})
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(install)
Vue.use(
  vaxTool,
  {
    enumKeys: [],
    ruleKeys: [],
    appCallBack: (app) => {
      app.putData('title', { show: 0, fullScreen: true })
      Vue.prototype.appInfo = { ...app.settings, hasFullScreen: !app.versionIsHigherThan(5370) }
    },
    networkParam: {
      afterCallBack: (res) => {
        console.log(app)
        console.log('===after callback===', res)
        const { code, msg = '' } = res || {}
        if ([500701, 500702, 500101].includes(code)) {
          // alert(msg)
          // app.gotoLogin(true)
        //  Toast.clear(msg)
        } else if (code === 716508) {
          console.log('xxxxxxxxxxxxxxxxxxxxxxxx')
        } else if (![0, 950000, 3, 500301].includes(code) && code !== undefined) {
          // 950000: 唤起风控的弹窗， 3：商品没有资质的tip  500301: 云信的问题
          Toast.fail(msg)
        }
      }
    },
    callback: ({
      auth,
      http,
      enumValue,
      ruleValue,
      app,
      vaxUtils,
      peach
    }) => {
      new Vue({
        router,
        store,
        render: (h) => h(App)
      }).$mount('#app')
    }
  }
)

